import { render, staticRenderFns } from "./MessageLocation.vue?vue&type=template&id=a0f2ff68&"
import script from "./MessageLocation.vue?vue&type=script&lang=ts&"
export * from "./MessageLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports